import { isManagerOrAdmin } from 'shared/domain/role/isManagerOrAdmin';
import { isVisibleNoAccess } from 'shared/domain/role/isVisibleNoAccess';
import { hasProcessAndSiteAccess } from 'shared/domain/user/hasProcessAndSiteAccess';
import {
  SubmitterOnAccessChangeView,
  TargetUserOnAccessChangeView,
} from 'shared/domain/user/types/view';
import { AccessLevelModel } from '../mapping/accessLevel/model/types';

function isAccessChangeForbiddenForSubmitter(
  submitterAccessLevel: AccessLevelModel,
  submitter: SubmitterOnAccessChangeView,
  targetUser: TargetUserOnAccessChangeView
): { disabled: boolean; reasons: string[] | null } {
  const cannotEdit = submitterAccessLevel !== AccessLevelModel.EDIT;
  const isSelf = targetUser._id === submitter._id;

  if (cannotEdit) {
    return { disabled: true, reasons: ['tooltip_action_forbidden' as const] };
  }
  if (isSelf) {
    return {
      disabled: true,
      reasons: ['tooltip_access_self_edit_unavailable' as const],
    };
  }
  if (isManagerOrAdmin(targetUser.role)) {
    return {
      disabled: true,
      reasons: ['tooltip_access_cannot_change_for_manager_or_admin' as const],
    };
  }
  if (isVisibleNoAccess(targetUser.role)) {
    return {
      disabled: true,
      reasons: ['tooltip_access_cannot_change_for_visible_no_access' as const],
    };
  }
  return {
    disabled: false,
    reasons: null,
  };
}

export function isAccessChangeForbidden({
  submitterAccessLevel,
  submitter,
  targetUser,
  siteId,
  processId,
}: {
  submitterAccessLevel: AccessLevelModel;
  submitter: SubmitterOnAccessChangeView;
  targetUser: TargetUserOnAccessChangeView;
  siteId: string;
  processId: string;
}): { disabled: boolean; reasons: string[] | null } {
  const { result, reasons } = hasProcessAndSiteAccess({
    targetUser,
    siteId,
    processId,
  });
  if (!result) {
    return { disabled: true, reasons };
  }

  if (isManagerOrAdmin(targetUser.role)) {
    return {
      disabled: true,
      reasons: ['tooltip_access_cannot_change_for_manager_or_admin' as const],
    };
  }

  return isAccessChangeForbiddenForSubmitter(
    submitterAccessLevel,
    submitter,
    targetUser
  );
}
